import { AdditionalInfoSearchDto, ContactSearchDto, AliasSearchDto, BiographicalSearchDto, DnaProfileSearchDto, EmploymentSearchDto, IdentificationDocSearchDto, PhysicalFeaturesSearchDto, PhysicalInfoSearchDto } from "@app/api2/api";

export type SearchCriteriaParamsType = (BiographicalSearchDto | PhysicalInfoSearchDto | ContactSearchDto | IdentificationDocSearchDto | DnaProfileSearchDto | EmploymentSearchDto | PhysicalFeaturesSearchDto | AliasSearchDto | AdditionalInfoSearchDto) & {
  discriminator: string;
} | null | undefined;

export interface SearchCriteria {
  id: string;
  searchType: string;
  // params: Record<string, any>;
  params: SearchCriteriaParamsType;

  operator: 'AND' | 'OR' | 'NOT' | null;
}


export const SEARCH_TYPES_NAMES = {
  BiographicalSearchDto: 'BiographicalSearchDto',
  PhysicalInfoSearchDto: 'PhysicalInfoSearchDto',
  ContactSearchDto: 'ContactSearchDto',
  IdentificationDocSearchDto: 'IdentificationDocSearchDto',
  DnaProfileSearchDto: 'DnaProfileSearchDto',
  EmploymentSearchDto: 'EmploymentSearchDto',
  PhysicalFeaturesSearchDto: 'PhysicalFeaturesSearchDto',
  AliasSearchDto: 'AliasSearchDto',
  AdditionalInfoSearchDto: 'AdditionalInfoSearchDto'
};

export const SEARCH_TYPES = [
  { key: SEARCH_TYPES_NAMES.BiographicalSearchDto, text: 'Biographical Data', value: SEARCH_TYPES_NAMES.BiographicalSearchDto },
  { key: SEARCH_TYPES_NAMES.PhysicalInfoSearchDto, text: 'Physical Characteristics', value: SEARCH_TYPES_NAMES.PhysicalInfoSearchDto },
  { key: SEARCH_TYPES_NAMES.ContactSearchDto, text: 'Contact Information', value: SEARCH_TYPES_NAMES.ContactSearchDto },
  { key: SEARCH_TYPES_NAMES.IdentificationDocSearchDto, text: 'Identification Documents', value: SEARCH_TYPES_NAMES.IdentificationDocSearchDto },
  { key: SEARCH_TYPES_NAMES.DnaProfileSearchDto, text: 'DNA Profile', value: SEARCH_TYPES_NAMES.DnaProfileSearchDto },
  { key: SEARCH_TYPES_NAMES.EmploymentSearchDto, text: 'Employment History', value: SEARCH_TYPES_NAMES.EmploymentSearchDto },
  { key: SEARCH_TYPES_NAMES.PhysicalFeaturesSearchDto, text: 'Physical Features & Distinguishing Marks', value: SEARCH_TYPES_NAMES.PhysicalFeaturesSearchDto },
  { key: SEARCH_TYPES_NAMES.AliasSearchDto, text: 'Aliases', value: SEARCH_TYPES_NAMES.AliasSearchDto },
  { key: SEARCH_TYPES_NAMES.AdditionalInfoSearchDto, text: 'Additional Info', value: SEARCH_TYPES_NAMES.AdditionalInfoSearchDto }
];

export const BOOLEAN_OPERATORS = [
  { key: 'and', text: 'AND', value: 'AND' },
  { key: 'or', text: 'OR', value: 'OR' },
  { key: 'not', text: 'NOT', value: 'NOT' }
];
